<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.85009 1.83327C5.34626 0.969272 4.09817 0.969272 3.59434 1.83327L0.673226 6.84216C0.167047 7.71102 0.792238 8.80555 1.8011 8.80555H7.64333C8.65219 8.80555 9.27755 7.71131 8.77137 6.84245L5.85009 1.83327ZM4.72221 2.8768L7.305 7.30555H2.13943L4.72221 2.8768Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.6389 6.66667C10.6389 4.25809 12.5914 2.30556 15 2.30556C17.4086 2.30556 19.3611 4.25809 19.3611 6.66667C19.3611 9.07524 17.4086 11.0278 15 11.0278C12.5914 11.0278 10.6389 9.07524 10.6389 6.66667ZM15 3.80556C13.4198 3.80556 12.1389 5.08652 12.1389 6.66667C12.1389 8.24682 13.4198 9.52778 15 9.52778C16.5801 9.52778 17.8611 8.24682 17.8611 6.66667C17.8611 5.08652 16.5801 3.80556 15 3.80556Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.52777 13.0556C4.52777 12.0277 5.36102 11.1944 6.38888 11.1944H10.2778C11.3056 11.1944 12.1389 12.0277 12.1389 13.0556V16.9444C12.1389 17.9723 11.3056 18.8056 10.2778 18.8056H6.38888C5.36102 18.8056 4.52777 17.9723 4.52777 16.9444V13.0556ZM6.38888 12.6944C6.18944 12.6944 6.02777 12.8561 6.02777 13.0556V16.9444C6.02777 17.1439 6.18944 17.3056 6.38888 17.3056H10.2778C10.4772 17.3056 10.6389 17.1439 10.6389 16.9444V13.0556C10.6389 12.8561 10.4772 12.6944 10.2778 12.6944H6.38888Z"
            fill="currentColor"
        />
    </svg>
</template>
